import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import FooterBannerCarousel from './FooterBannerCarousel';
import { BannerTarget, findBanner } from '../../util/banner';
import { UserInfo } from '../index';

type FooterBannerProps = {
  target: BannerTarget;
  userInfo: UserInfo;
};

const BANNER_MAX_WIDTH = 768;
const MOBILE_MAX_WIDTH = 480;
const BANNER_MAX_HEIGHT = 240;

const FooterBanner = ({ target, userInfo }: FooterBannerProps) => {
  const [bannerHeight, setBannerHeight] = useState<string | number>(0);
  const [isSmallBanner, setIsSmallBanner] = useState<boolean>(false);
  const [currentIdx, setCurrentIdx] = useState<number>(0);

  const bannerItems = findBanner(target, userInfo.country, isSmallBanner);

  useEffect(() => {
    const width = window.innerWidth;
    if (!width) {
      return;
    }

    setBannerHeight(width < BANNER_MAX_WIDTH ? width * 0.3125 : BANNER_MAX_HEIGHT);
    setIsSmallBanner(width < MOBILE_MAX_WIDTH);
  }, []);

  return (
    <div
      className={styles.footerBanner}
      style={{ height: bannerHeight, maxWidth: BANNER_MAX_WIDTH }}
      data-id="footer_banner"
    >
      <FooterBannerCarousel
        data={bannerItems}
        bannerHeight={bannerHeight}
        currentIdx={currentIdx}
        setCurrentIdx={setCurrentIdx}
      />
      <div className={styles.adLogo}>AD</div>
      {bannerItems.length > 1 && (
        <div className={styles.pagination}>
          {currentIdx + 1} / {bannerItems.length}
        </div>
      )}
    </div>
  );
};

export default FooterBanner;
